const browserDeploy = function () {
  throw new Error('Deploys not supported in the browser')
}

module.exports = browserDeploy
